import * as React from 'react';

import { Grid } from "@material-ui/core";
import { BarrGraphic } from '../../shared/graphics/barrGraphic/BarrGraphic';
import { BigNumberGraphic } from '../../shared/graphics/bigNumbers/BigNumberGraphic';
import * as Moment from 'moment';
import Rest from '../../../../../services/Rest';


// tslint:disable-next-line:no-empty-interface
export interface IAnalyticsUserDetailProps {
    endDate: any,
    initialDate: any,
    email: string,
    errorMessage(error:string): void,
    setDetailState(isDetail:boolean, user:any): void,
}

// tslint:disable-next-line:no-empty-interface
export interface IAnalyticsUserDetailState {
    accessData: number,
    downloadsData: number,
    email: string,
    endDate: any,
    filtersRanking: any[],
    initialDate: any,
    loadingBigNumber: boolean,
    loadingGraphic: boolean,
    pagesRanking: any[],
    sessionTimeData: string
}

export class AnalyticsUserDetail extends React.Component<IAnalyticsUserDetailProps, IAnalyticsUserDetailState> {
    constructor(props: IAnalyticsUserDetailProps) {
        super(props);
        this.state = {
            accessData: 0,
            downloadsData: 0,
            email: '',
            endDate: undefined,
            filtersRanking: [],
            initialDate: undefined,
            loadingBigNumber: false,
            loadingGraphic: false,
            pagesRanking: [],
            sessionTimeData: ''
        }
    }

    public async componentWillMount () {
        this.requestAnalyticsData(this.props.initialDate, this.props.endDate, this.props.email);
    }

    public async componentDidUpdate(prevProps:any) {
        // Caso alguma das propriedades tenha mudado, deve-se atualizar os dados de acordo com os novos parâmetros
        if (prevProps.initialDate !== this.props.initialDate || prevProps.endDate !== this.props.endDate 
            || prevProps.email !== this.props.email) {
            this.requestAnalyticsData(this.props.initialDate, this.props.endDate, this.props.email);
        }
    }

    public render() {
        const pageDados = {
            rows: this.state.pagesRanking
        };
        const filterDados = {
            rows: this.state.filtersRanking
        };
        let formatedSessionTime = '00:00:00';
        if(this.state.sessionTimeData) {
            const seconds = Number(this.state.sessionTimeData);
            if(seconds > 0) {
                formatedSessionTime = Moment.utc(seconds * 1000).format('HH:mm:ss');
            }
        }
        return (
            <Grid container={true} spacing={16} className="publisher-sale-panel panel-grid">
                <Grid item={true} xs={4} sm={4}>
                    <BigNumberGraphic title='Acessos' value={this.state.accessData} loading={this.state.loadingBigNumber} />
                </Grid>
                <Grid item={true} xs={4} sm={4}>
                    <BigNumberGraphic title='Tempo de sessão' value={formatedSessionTime} loading={this.state.loadingBigNumber} />
                </Grid>
                <Grid item={true} xs={4} sm={4}>
                    <BigNumberGraphic title='Downloads' value={this.state.downloadsData} loading={this.state.loadingBigNumber} />
                </Grid>


                <Grid item={true} xs={6} sm={6} >
                    <BarrGraphic dataProp={pageDados} dimensionIndex={1} metricsIndex={2} title='Painéis mais utilizados' loading={this.state.loadingGraphic} />
                </Grid>

                <Grid item={true} xs={6} sm={6} >
                    <BarrGraphic dataProp={filterDados} dimensionIndex={2} metricsIndex={0} title='Filtros mais utilizados' loading={this.state.loadingGraphic} />
                </Grid>
            </Grid>
        );
    }

    private async requestAnalyticsData(initialDate:any, finalDate:any, email:string) {
        if(email && email.length > 0) {
            this.requestGraphicData(initialDate, finalDate, email);
            this.requestBigNumbersData(initialDate, finalDate, email);
        } else {
            this.props.errorMessage('Nenhum email informado para consulta');
        }
    }

    private async requestGraphicData(initialDate:any, finalDate:any, email:string) {
        const graphicBody:any = {
            requestBody: {
                reportRequests: [
                    {
                        dateRanges: [
                            {
                                endDate: finalDate,
                                startDate: initialDate
                            },
                        ],
                        dimensionFilterClauses: [
                            {
                                filters: [
                                    {
                                        dimensionName: 'ga:dimension1',
                                        expressions: [email],
                                        operator: 'IN_LIST'
                                    }
                                ]
                            }
                        ],
                        dimensions: [
                            {name: 'ga:dimension1'},
                            {name: 'ga:pagePath'}
                        ],
                        metrics: [
                            {expression: 'ga:sessions'},
                            {expression: 'ga:avgSessionDuration'},
                            {expression: 'ga:pageviews'}
                        ],
                        orderBys: [
                            {
                                fieldName: 'ga:pageviews',
                                orderType: 'VALUE',
                                sortOrder: 'DESCENDING'
                            }
                        ]
                    },
                    {
                        dateRanges: [
                            {
                                endDate: finalDate,
                                startDate: initialDate
                            },
                        ],
                        dimensionFilterClauses: [
                            {
                                filters: [
                                    {
                                        dimensionName: 'ga:dimension1',
                                        expressions: [email],
                                        operator: 'IN_LIST'
                                    }
                                ]
                            },
                            {
                                filters: [
                                    {
                                        dimensionName: 'ga:eventAction',
                                        expressions: ['Filter'],
                                        operator: 'IN_LIST'
                                    }
                                ]
                            }
                        ],
                        dimensions: [
                            {name: 'ga:dimension1'},
                            {name: 'ga:eventAction'},
                            {name: 'ga:eventCategory'}
                        ],
                        metrics: [
                            {expression: 'ga:totalEvents'}
                        ],
                        orderBys: [
                            {
                                fieldName: 'ga:totalEvents',
                                orderType: 'VALUE',
                                sortOrder: 'DESCENDING'
                            }
                        ]
                    }
                ],
            },
        };

        this.setState({loadingGraphic: true});
        const graphicResponse = await Rest.POST('analytics',graphicBody);
        if(graphicResponse && graphicResponse.data && graphicResponse.data.data && graphicResponse.data.data.reports && graphicResponse.data.data.reports.length > 0 
            && graphicResponse.data.data.reports[0] && graphicResponse.data.data.reports[0].data) {

            if(graphicResponse.data.data.reports[0].data.rows && graphicResponse.data.data.reports.length === 2) {
                this.setState({
                    filtersRanking: graphicResponse.data.data.reports[1].data.rows,
                    loadingGraphic: false, 
                    pagesRanking: graphicResponse.data.data.reports[0].data.rows,
                });
                return graphicResponse.data.data.reports[0].data.rows;
            } else {
                this.props.errorMessage('Nenhum dado encontrado');
            }
        } else {
            let message = 'Falha ao consultar dados';
            if(graphicResponse && graphicResponse.statusText && graphicResponse.statusText.length > 0) {
                message = graphicResponse.statusText
            }
            this.props.errorMessage(message);
        }
        this.setState({filtersRanking: [], loadingGraphic: false, pagesRanking: []});
        return null;
    }

    private async requestBigNumbersData(initialDate:any, finalDate:any, email:string) {
        const bigNumbersBody: any = {
            requestBody: {
                reportRequests: [
                    {
                        dateRanges: [
                            {
                                endDate: finalDate,
                                startDate: initialDate
                            },
                        ],
                        dimensionFilterClauses : [
                            {
                                filters: [
                                    {
                                        dimensionName: 'ga:dimension1',
                                        expressions: [email],
                                        operator: 'IN_LIST'
                                    }
                                ]
                            }
                        ],
                        dimensions: [
                            {name: 'ga:dimension1'}
                        ],
                        metrics: [
                            {expression: 'ga:sessions'},
                            {expression: 'ga:avgSessionDuration'}
                        ]
                    },
                    {
                        dateRanges: [
                            {
                                endDate: finalDate,
                                startDate: initialDate
                            },
                        ],
                        dimensionFilterClauses : [
                            {
                                filters: [
                                    {
                                        dimensionName: 'ga:dimension1',
                                        expressions: [email],
                                        operator: 'IN_LIST'
                                    }
                                ]
                            },
                            {
                                filters: [
                                    {
                                        dimensionName: 'ga:eventAction',
                                        expressions: ['Download'],
                                        operator: 'IN_LIST'
                                    }
                                ]
                            }
                        ],
                        dimensions: [
                            {name: 'ga:dimension1'},
                            {name: 'ga:eventAction'}
                        ],
                        metrics: [
                            {expression: 'ga:totalEvents'}
                        ]
                    }
                ]
            }
        };

        this.setState({loadingBigNumber: true});
        const bigNumbersResponse = await Rest.POST('analytics',bigNumbersBody);
        if(bigNumbersResponse && bigNumbersResponse.data && bigNumbersResponse.data.data && bigNumbersResponse.data.data.reports 
            && bigNumbersResponse.data.data.reports.length > 0 && bigNumbersResponse.data.data.reports[0] 
            && bigNumbersResponse.data.data.reports[0].data) {

            if(bigNumbersResponse.data.data.reports && bigNumbersResponse.data.data.reports.length === 2) {
                let accesDataAnalytics : number = 0;
                let sessionTimeDataAnalytics : string = '';
                if(bigNumbersResponse.data.data.reports[0].data.rows && bigNumbersResponse.data.data.reports[0].data.rows.length > 0) {
                    accesDataAnalytics = bigNumbersResponse.data.data.reports[0].data.rows[0].metrics[0].values[0];
                    sessionTimeDataAnalytics = bigNumbersResponse.data.data.reports[0].data.rows[0].metrics[0].values[1];
                }

                let downloadDataAnalytics : number = 0;
                if(bigNumbersResponse.data.data.reports[1].data.rows && bigNumbersResponse.data.data.reports[1].data.rows.length > 0) {
                    downloadDataAnalytics = bigNumbersResponse.data.data.reports[1].data.rows[0].metrics[0].values[0];
                }

                this.setState({
                    accessData: accesDataAnalytics, 
                    downloadsData: downloadDataAnalytics,
                    loadingBigNumber: false, 
                    sessionTimeData: sessionTimeDataAnalytics
                });
                return bigNumbersResponse.data.data.reports[0].data.rows;
            } else {
                this.props.errorMessage('Nenhum dado encontrado');
            }
        } else {
            let message = 'Falha ao consultar dados';
            if(bigNumbersResponse && bigNumbersResponse.statusText && bigNumbersResponse.statusText.length > 0) {
                message = bigNumbersResponse.statusText
            }
            this.props.errorMessage(message);
        }
        this.setState({accessData: 0, downloadsData: 0, loadingBigNumber: false, sessionTimeData: ''});
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/analytics/tabs/users/AnalyticsUserDetail.tsx